export default __webpack_public_path__ + "static/media/girl2.30853a9b.svg";